import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTripadvisor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
			fill: "#34E0A1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1767 10.0492L19.3834 8.73629H16.7074C15.3678 7.82119 13.7499 7.28824 12.0001 7.28824C10.2526 7.28824 8.63926 7.82234 7.30182 8.73629H4.61914L5.82585 10.0492C5.08619 10.724 4.6225 11.6961 4.6225 12.7754C4.6225 14.8123 6.27392 16.4637 8.31079 16.4637C9.2784 16.4637 10.1599 16.0905 10.8181 15.4804L12.0002 16.7676L13.1823 15.4816C13.8404 16.0916 14.7208 16.4637 15.6884 16.4637C17.7253 16.4637 19.3789 14.8123 19.3789 12.7754C19.38 11.695 18.9164 10.7229 18.1767 10.0492ZM8.31189 15.2715C6.9331 15.2715 5.81581 14.1542 5.81581 12.7754C5.81581 11.3966 6.93313 10.2793 8.31189 10.2793C9.69065 10.2793 10.808 11.3966 10.808 12.7754C10.808 14.1542 9.69065 15.2715 8.31189 15.2715ZM12.0013 12.7028C12.0013 11.0603 10.8069 9.65027 9.23032 9.04802C10.0828 8.69158 11.018 8.49382 12.0001 8.49382C12.9823 8.49382 13.9186 8.69158 14.7711 9.04802C13.1957 9.65139 12.0013 11.0603 12.0013 12.7028ZM15.6896 15.2715C14.3108 15.2715 13.1935 14.1542 13.1935 12.7754C13.1935 11.3966 14.3108 10.2793 15.6896 10.2793C17.0683 10.2793 18.1856 11.3966 18.1856 12.7754C18.1856 14.1542 17.0683 15.2715 15.6896 15.2715ZM15.6896 11.4659C14.9666 11.4659 14.3812 12.0514 14.3812 12.7743C14.3812 13.4972 14.9666 14.0827 15.6896 14.0827C16.4125 14.0827 16.9979 13.4972 16.9979 12.7743C16.9979 12.0525 16.4125 11.4659 15.6896 11.4659ZM9.62026 12.7754C9.62026 13.4983 9.03478 14.0838 8.31189 14.0838C7.589 14.0838 7.00351 13.4983 7.00351 12.7754C7.00351 12.0525 7.589 11.467 8.31189 11.467C9.03478 11.4659 9.62026 12.0525 9.62026 12.7754Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgTripadvisor);
export { ForwardRef as ReactComponent };
